import React from "react";
import { Avatar, Box, Chip, IconButton, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import { useClinicTheme } from "../../theme";
import { COLORS } from "../../styles/uiConstants";
import { getRoleLabel } from "../../utils/roleLabels";
import { getStatusChipSx, getRoleChipSx } from "./constants";
import ClinicLabel from "../../components/atoms/ClinicLabel";

/**
 * Kullanıcı listesinin mobil (md altı) kart gösterimi.
 * Kartın tamamı dokunulabilir → detay drawer'ını açar; ⋮ butonu bağımsız çalışır.
 */
export default function UserCard({ user, onOpenDetail, onMenuOpen, canUseActions = false }) {
  const { palette } = useClinicTheme();

  return (
    <Box
      onClick={() => onOpenDetail?.(user)}
      sx={{
        display: "flex",
        gap: 1.5,
        p: 1.5,
        borderRadius: 2,
        border: `1px solid ${COLORS.slate200}`,
        bgcolor: COLORS.white,
        cursor: "pointer",
        "&:active": { bgcolor: alpha(palette.primary, 0.04) },
      }}
    >
      <Avatar
        variant="rounded"
        sx={{
          width: 40,
          height: 40,
          fontWeight: 700,
          bgcolor: alpha(palette.primary, 0.12),
          color: palette.primary,
        }}
      >
        {(user?.name || "?")[0].toUpperCase()}
      </Avatar>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 600, fontSize: "0.875rem", color: COLORS.slate800 }} noWrap>
          {user?.name} {user?.surname}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.5 }}>
          <Chip
            size="small"
            label={getRoleLabel(user?.role)}
            sx={{ ...getRoleChipSx(user?.role), height: 20, fontSize: "0.625rem" }}
          />
          <Chip
            size="small"
            label={user?.accountStatus}
            sx={{ ...getStatusChipSx(user?.accountStatus), height: 22, fontSize: "0.6875rem" }}
          />
        </Box>

        <Box sx={{ mt: 0.75 }}>
          <ClinicLabel clinic={user?.clinic} size={20} />
        </Box>

        <Typography sx={{ fontSize: "0.75rem", color: COLORS.slate500, mt: 0.25 }} noWrap>
          {user?.email}
        </Typography>
      </Box>

      {canUseActions ? (
        <IconButton
          size="small"
          aria-label="İşlemler"
          onClick={(e) => {
            e.stopPropagation();
            onMenuOpen?.(e, user);
          }}
          sx={{ alignSelf: "flex-start" }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      ) : null}
    </Box>
  );
}
